<template>
  <div>
    <div style="padding:0 20px;">
      <div style="margin-bottom:8px">{{$t('edit.hpInfo.hpIcon')}}</div>
      <a-select
        style="width: 100%"
        :value="selectedTitle"
        :default-value="$t('edit.hpInfo.dynamicIcon')"
        @change="handleChange"
      >
        <a-select-option key="1" value="1">{{$t('edit.hpInfo.dynamicIcon')}}</a-select-option>
        <a-select-option key="0" value="0">{{this.$t('edit.hpInfo.staticIcon')}}</a-select-option>
        <a-select-option key="100" value="100">
          <material-select ref="materialList"  :type="1" @selected="handleSelected">
            <template slot="body">
              <span>{{$t('publish.addMer')}}</span>
            </template>
          </material-select>
          </a-select-option>
      </a-select>
    </div>
    <div class="icon-content">
      <div v-if="isloading" class="loading">
        <a-spin :spinning="isloading" />
      </div>
      <template v-else>
        <div
          class="icon-content-item"
          :class="{active: item.icon_url === currentIcon}"
          v-for="(item, index) in currTypeIcons"
          :key="index"
          @click="onSelectIcon(item)"
        >
          <img :src="item.thumb_path" />
        </div>
      </template>
    </div>

    <!-- <a-modal v-model="modalVisible" title="素材庫" :footer="false" :width="900">
      <a-tabs default-active-key="1">
        <a-tab-pane key="1">
          <span slot="tab">
            <a-icon type="image" />圖片
          </span>
          <material-select ref="materialList"  :type="1" @selected="handleSelected">
            <template slot="body">
              <a-button type="primary" ghost>{{$t('edit.sandboxs.selectImg2')}}</a-button>
            </template>
          </material-select>
        </a-tab-pane>
      </a-tabs>
    </a-modal> -->
    <!-- <a-row style="margin-top: 10px">
            <a-col :span="18">
              <a-slider :min="1" :max="99" :step="1" v-model="currScale" />
            </a-col>
    </a-row> -->
  </div>
</template>

<script>
import { getAllIcons } from "@/api/work";
import MaterialSelect from "@/components/MaterialSelect";

export default {
  components: { MaterialSelect },
  props: {
    currentIcon: {
      type: String,
      required: true,
    },
    type:{
      type:Number,
      default:1
    }
  },
  data() {
    return {
      currScale:50,
      currTypeIcons: [],
      allHotIcon: [],
      isloading: false,
      modalVisible: false,
      selectedTitle: this.$t('edit.hpInfo.dynamicIcon'),
      titles: {
        "0": this.$t('edit.hpInfo.staticIcon'),
        "1": this.$t('edit.hpInfo.dynamicIcon'),
        "100": this.$t('publish.addMer'),
      }
    };
  },
  created() {
    // 獲取熱點圖表
    this.isloading = true;
    getAllIcons({type:this.type})
      .then((res) => {
        this.allHotIcon = res.data;
        this.isloading = false;
        this.handleChange(1);
      })
      .catch((err) => {
        console.log(err);
        this.isloading = false;
      });
  },
  methods: {
    handleChange(value) {
      this.selectedTitle = this.titles[value]
      let tempData = [];
      if (value === "100") {
        this.modalVisible = true;
      } else {
        const tempData = this.allHotIcon.filter(
          (item) => item.is_dynamic === +value
        );
        this.currTypeIcons = tempData;
      }
    },
    handleSelected(item) {
      console.log("selected=", item);
      const currItem = {
        icon_url: item.url,
        is_dynamic: 0,
        thumb_path: item.url,
      };
      //圖標回顯
      this.currTypeIcons = [currItem];
      // 圖標選中
      this.$emit("onSelectIcon", currItem);
      this.$emit('iconScale', );
      //  close modal
      this.modalVisible = false;
    },
    onSelectIcon(item) {
      this.$emit("onSelectIcon", item);
    },
  },
};
</script>

<style lang="less" scoped>
.icon-content {
  margin: 10px 20px;
  padding: 10px 4px;
  max-height: 200px;
  overflow: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  background-color: #212121;
  border-radius: 4px;
}
.icon-content-item {
  width: 25%;
  height: 51px;
  padding: 4px;
  cursor: pointer;
  border: 2px solid transparent;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon-content-item img {
  width: 43px;
  height: 43px;
}
.active {
  border: 2px solid #17a6ad;
}
.loading {
  text-align: center;
  width: 100%;
}
</style>
